import { defineComponent as _defineComponent } from 'vue'
import CollapsableCard from "@/components/bootstrap/CollapsableCard.vue";
import Toggle from "@/components/bootstrap/Toggle.vue";
import {useTranslations} from "@/hooks/useTranslations";
import {pascalCaseToHuman} from "@/utils/Helpers";
import {DietaryTypes} from "@/models/NutritionLabels/DietaryTypes";
import {computed, ref, watch} from "vue";

type DietaryConfigurationProps = {
  value: DietaryTypes[],
  includeDietary?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DietaryConfiguration',
  props: {
    value: null,
    includeDietary: { type: Boolean }
  },
  emits: ["fetch-preview", "update:value", "update:includeDietary"],
  setup(__props: any, { emit }) {

const props = __props as {
  value: DietaryTypes[],
  includeDietary?: boolean,
};



const translations = useTranslations();

const model = ref(props.value.map((a) => a.toString()));
const includeDietaryModel = ref(props.includeDietary ?? true);
const iterableDietarys = computed(() => Object.keys(DietaryTypes).filter((key) => isNaN(Number(key))));

watch(
  () => props.value,
  (newVal) => {
    model.value = newVal.map((a) => a.toString());
  },
  { deep: true, immediate: true }
);

watch(
  () => props.includeDietary,
  (newVal) => {
    includeDietaryModel.value = newVal ?? true;
  },
  { immediate: true }
);

function onIncludeDietaryChanged() {
  emit("update:includeDietary", includeDietaryModel.value);
  emit("fetch-preview");
}

function onDietaryToggled(dietary: string, isChecked: boolean) {
  if (isChecked) {
    model.value.push(dietary);
  }

  else {
    model.value = model.value.filter((x) => x != dietary);
  }

  emit('update:value', model.value.map((a) => DietaryTypes[a]));
  emit('fetch-preview');
}

return { __sfc: true,props, emit, translations, model, includeDietaryModel, iterableDietarys, onIncludeDietaryChanged, onDietaryToggled, CollapsableCard, Toggle, pascalCaseToHuman, DietaryTypes }
}

})